import { Component } from '@angular/core';

@Component({
  selector: 'app-summary-page',
  templateUrl: './summary.page.html',
  styleUrls: ['./summary.page.scss'],
})
export class SummaryPage {}
